import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BreadCrumbInput } from '../../shared/models/BreadCrumbInputModel';
import { ComparisonService } from '../../shared/providers/comparison.service';


@Component({
    selector: 'app-portfolio-analysis',
    templateUrl: './portfolio-analysis.component.html'
})

export class PortfolioAnalysisComponent implements OnInit {

    protected readonly BASE_URL: string = environment.base_url;
    @Input() exchangeId: number;
    dtOptions = {};
    table: DataTableDirective;
    user: any;
    loggedinUserId: any;
    portfolioAnalysisList: any;

    constructor(private _ValidationService: ValidationService, private router: Router, public comparisonService: ComparisonService,
        private authService: AuthenticationService, private modalService: BsModalService, private http: HttpClient) {
    }

    ngOnInit() {
        this.user = this.authService.user;
        this.loggedinUserId = this.user.Id;
        this.loadData();
    }

    loadData() {

        const that = this;

        const filter =
            {
                UserId: this.loggedinUserId,
                ExchangeId: this.exchangeId
            }

        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            processing: true,
            info: false,
            "pageLength": 50,
            language: {
                zeroRecords: null,
            },
            "order": [[0, "desc"]],
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                dataTablesParameters.Extra_param = filter;

                const httpHeader = this._ValidationService.GetAuthHeader();
                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/user1031/getPortfolioAnalysisList',
                        dataTablesParameters, httpHeader
                    ).subscribe(resp => {
                        that.portfolioAnalysisList = resp.data ? resp.data : [];
                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }


                    });
            },
            columns: [
                //{ data: 'AnalysisId' },
                { data: 'AnalysisName' },
                { data: 'NoOfProperties' },
                { data: 'TotalPrice' },
                { data: 'TotalNOI' },
                { data: 'AvgCapRate' }

            ]
        };
    }
    compare(AnalysisId) {
        this.router.navigateByUrl("/compare/" + AnalysisId + "?link=" + (this.router.url));
    }
}
